import { Injectable } from '@angular/core';
import AuthService from '../../../../old-crazy-web-frontend/src/app/auth/auth.service';
import { ConfigService } from '../../config/config.service';

@Injectable()
export class Ng1AuthService {
  private authService: AuthService;

  constructor(private configService: ConfigService) {
    this.authService = configService.getValue('AuthService');
  }

  hasPermission(permission: string): boolean {
    return this.authService && this.authService.hasPermission(permission);
  }
}
